<template>
  <div class="row mb-2 py-2 bg-white shadow mx-0 rounded unternehmen-row" @click="openUnternehmen()">
    <div class="col my-auto">{{ unternehmen.titel }}</div>
    <div class="col my-auto">{{ unternehmen.realm }}</div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType } from 'vue';
  import { useRouter } from 'vue-router';
  import { Unternehmen } from '@/models/UnternehmenModels';

  //#endregion

  const { unternehmen } = defineProps({
    unternehmen: {
      type: Object as PropType<Unternehmen>,
      required: true,
    },
  });

  const router = useRouter();

  function openUnternehmen() {
    router.push({ name: 'UnternehmenDetails', params: { id: unternehmen.id } });
  }
</script>

<style lang="scss" scoped>
  .unternehmen-row:hover {
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #cee0fa !important;
    }
  }
</style>
